export default __webpack_public_path__ + "static/media/element_102.1d9b1f7a.webp";